import type { Doc } from "building-types/doc";
import type { EdgeModifierHandle } from "building-types/handles/docEntityHandleTypes";
import type { EdgeModifier } from "building-types/modifiers/edgeModifierTypes";

export function docGetEdgeModifier(doc: Doc, handle: EdgeModifierHandle): EdgeModifier {
  return doc.edgeModifiers[handle.id];
}
